export default __webpack_public_path__ + "static/media/popularService(2).012c8c55.png";